import { Modal, Box, ModalOverlay, ModalContent, ModalCloseButton, ModalHeader, ModalBody, Text } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'

function TemplatePreviewModal({ isOpen, onClose, tempBody, tempFooter, tempHeader, commonSubjectLine }) {
    const [combinedTemp, setCombinedTemp] = useState("");

    useEffect(() => {
        
        setCombinedTemp(`${tempHeader || ""}${tempBody || ""}${tempFooter || ""}`);
    }, [tempHeader, tempBody, tempFooter]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size={'80%'} scrollBehavior='inside'>
            <ModalOverlay bg={'#fff'} />
            <ModalContent w={'auto'}>
                <ModalHeader fontSize={'sm'}>Template Preview</ModalHeader>
                <ModalCloseButton onClick={onClose} />
                <ModalBody w={'100%'}>
                    <Text>
                        Subject Line : {commonSubjectLine}
                    </Text>
                    <Box
                        as="iframe"
                        title="Email template preview"
                        srcDoc={combinedTemp || '<b>No Preview Available</b>'}
                        sandbox=""
                        border={0}
                        w={'100%'}
                        h="70vh"
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default TemplatePreviewModal;
